import React from "react";
import db from "../../firebase";  
import { useCollectionData } from "react-firebase-hooks/firestore";
import { Link } from "react-router-dom";

const Card = (props) => {
    const blogsRef = db.collection("blogs");
    const query = blogsRef.where("title", "==", props.title);
    const [post, loading, error] = useCollectionData(query);
    
    return (
        <Link to={post ? `/posts/${post[0].title}` : ""}>
            {/* Made with Bootstrap cards */}
            <div className="card">
                {loading && <h1>Loading...</h1>}
                {error && <h1>{error}</h1>}
                <img src={post && post[0].featuredImg} className="card-img-top" alt="..." />
                <div className="card-body">
                    <h5 className="card-title">{post && post[0].title}</h5>
                </div>
            </div>
        </Link>
    );
}

export default Card;